export const GET_ALL_RELATED_USERS = 'GET_ALL_RELATED_USERS'
export const GET_ALL_RELATED_USERS_SUCCESSFUL = 'GET_ALL_RELATED_USERS_SUCCESSFUL'
export const GET_ALL_RELATED_USERS_ERROR = 'GET_ALL_RELATED_USERS_ERROR'